import { TextArea } from './styles'

export default TextArea